<template lang="html">
  <div class="shopify-create-app">
    <Guide
      :content="content"
      contentHeading="Create a Private App"
      :contentVideo="contentVideo"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyCreateApp',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'shopify-app-permissions',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>In order to connect your Shopify account to our platform, you are required to <a href="https://shopify.com/admin/apps/private/new" target="_blank">Create a private app</a> through the Shopify platform. <strong>Don't worry - It's not as hard as it sounds!</strong></p>

          <div class="helper-text">
            <ol>
              <li>
                <p>Go to the <a href="https://shopify.com/admin/apps/private/new" target="_blank">Create an app</a> page.</p>
                </li>

              <li>
                <p>The <strong>Private app name</strong> should be the name of your website.</p>
              </li>

              <li>
                <p>The <strong>Emergency developer email</strong> should be your own.</p>
              </li>
            </ol>
          </div>

          <p>Proceed once you have filled out the above information.</p>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/2+-+LIGHTBULB_ANIME_04.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
